"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultLogger = exports.DefaultLoggerContainer = void 0;
const LogLevel_1 = require("../abstract/LogLevel");
const voidLogger_1 = require("../void/voidLogger");
const Logger_1 = require("../abstract/Logger");
class DefaultLoggerContainer extends Logger_1.Logger {
    constructor() {
        super();
        this.defaultLogger = new voidLogger_1.VoidLogger();
    }
    close() {
        this.defaultLogger.close();
    }
    createChild(meta) {
        return this.defaultLogger.createChild(meta);
    }
    log(log) {
        const { level, message, meta } = log;
        switch (level) {
            case LogLevel_1.LogLevel.Fatal:
                this.defaultLogger.fatal(message, meta);
                break;
            case LogLevel_1.LogLevel.Error:
                this.defaultLogger.error(message, meta);
                break;
            case LogLevel_1.LogLevel.Warn:
                this.defaultLogger.warn(message, meta);
                break;
            case LogLevel_1.LogLevel.Info:
                this.defaultLogger.info(message, meta);
                break;
            case LogLevel_1.LogLevel.Debug:
                this.defaultLogger.debug(message, meta);
                break;
            case LogLevel_1.LogLevel.Trace:
                this.defaultLogger.trace(message, meta);
                break;
            case LogLevel_1.LogLevel.None:
                break;
        }
    }
    setDefaultLogger(logger) {
        // todo log warn if the current logger if not voidlogger
        this.defaultLogger = logger;
    }
}
exports.DefaultLoggerContainer = DefaultLoggerContainer;
exports.defaultLogger = new DefaultLoggerContainer();
//# sourceMappingURL=default.js.map